var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "slide-first-wrapper",
        { "dark-blue-mode": _vm.$route.meta.headerColor === "dark" }
      ],
      attrs: { id: "slide-first" },
      on: {
        mouseleave: function($event) {
          return _vm.openSideMenuOverflowElement($event)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "side-menu-navigation" },
        [
          _c("span", { staticClass: "links-header" }, [
            _vm._v(_vm._s(_vm.$t("sideMenu.platform")))
          ]),
          _c(
            "span",
            {
              staticClass: "link",
              on: {
                click: function($event) {
                  return _vm.tryRedirect("/gop/home", "GOP_HOME")
                }
              }
            },
            [_vm._m(0)]
          ),
          _c("span", { staticClass: "links-header" }, [
            _vm._v(_vm._s(_vm.$t("sideMenu.stories")))
          ]),
          _c(
            "div",
            {
              staticClass: "link",
              class: _vm.checkIsActivePage("/home"),
              on: {
                click: function($event) {
                  return _vm.tryRedirect("/home", "HOMEPAGE_DRC")
                }
              }
            },
            [
              _c("div", { staticClass: "hover-container" }, [
                _c("img", {
                  attrs: {
                    src: require("@/common/assets/icons/home.svg"),
                    alt: "home"
                  }
                }),
                _c("span", [_vm._v(_vm._s(_vm.$t("sideMenu.home")))])
              ])
            ]
          ),
          _c(
            "span",
            {
              staticClass: "link",
              class: _vm.checkIsActivePage("/submission/new-project-form"),
              on: {
                click: _vm.closeSideMenuWithRedirect,
                mouseenter: function($event) {
                  return _vm.openSideMenuOverflowElement($event)
                }
              }
            },
            [
              _c(
                "span",
                { staticClass: "hover-container create-story-button" },
                [
                  _c("img", {
                    staticClass: "plus",
                    attrs: {
                      src: require("@/common/assets/icons/plus.svg"),
                      alt: "plus"
                    }
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("sideMenu.create")))])
                ]
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "link",
              class: _vm.checkIsActivePage("/projects/search"),
              on: {
                click: function($event) {
                  _vm.tryRedirect(_vm.getBaseUrl(), "ALL_STORIES")
                }
              }
            },
            [
              _c("div", { staticClass: "hover-container" }, [
                _c("img", {
                  attrs: {
                    src: require("@/common/assets/icons/search.svg"),
                    alt: "search"
                  }
                }),
                _c("span", [_vm._v(_vm._s(_vm.$t("sideMenu.allStories")))])
              ])
            ]
          ),
          _vm.hasPermission(_vm.PERMISSIONS.additionalCmtAccess)
            ? _c(
                "router-link",
                {
                  staticClass: "link",
                  class: _vm.checkIsActivePage("/manage/content"),
                  attrs: { tag: "span", to: "/manage/content" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.closeSideMenu.apply(null, arguments)
                    },
                    mouseenter: function($event) {
                      return _vm.openSideMenuOverflowElement($event)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "hover-container" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/common/assets/icons/manage.svg"),
                        alt: "manage"
                      }
                    }),
                    _c("span", [_vm._v(_vm._s(_vm.$t("sideMenu.manage")))])
                  ])
                ]
              )
            : _vm._e(),
          _vm.hasPermission(_vm.PERMISSIONS.additionalCmtAccess)
            ? _c(
                "div",
                {
                  staticClass: "link",
                  class: _vm.checkIsActivePage("/control-panel"),
                  on: {
                    click: function($event) {
                      return _vm.tryRedirect(
                        "/control-panel/landing-page",
                        "CONTROL_PANEL"
                      )
                    },
                    mouseenter: function($event) {
                      return _vm.openSideMenuOverflowElement($event)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "hover-container" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/common/assets/icons/administration.svg"),
                        alt: "control-panel"
                      }
                    }),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("sideMenu.controlPanel")))
                    ])
                  ])
                ]
              )
            : _vm._e(),
          _c("span", { staticClass: "links-header" }, [
            _vm._v(_vm._s(_vm.$t("sideMenu.personal")))
          ]),
          _c(
            "div",
            {
              staticClass: "link",
              class: _vm.checkIsActivePage("/my-stories"),
              on: {
                click: function($event) {
                  return _vm.tryRedirect("/my-stories", "MY_STORIES")
                }
              }
            },
            [
              _c("div", { staticClass: "hover-container" }, [
                _c("img", {
                  attrs: {
                    src: require("@/common/assets/icons/file.svg"),
                    alt: "file"
                  }
                }),
                _c("span", [_vm._v(_vm._s(_vm.$t("sideMenu.myStories")))])
              ])
            ]
          ),
          _c(
            "div",
            {
              staticClass: "link",
              class: _vm.checkIsActivePage("/my-subscriptions"),
              on: {
                click: function($event) {
                  return _vm.tryRedirect(
                    "/my-subscriptions",
                    "MY_SUBSCRIPTIONS"
                  )
                }
              }
            },
            [
              _c("div", { staticClass: "hover-container" }, [
                _c("img", {
                  attrs: {
                    src: require("@/common/assets/icons/subscriptions.svg"),
                    alt: "file"
                  }
                }),
                _c("span", [_vm._v(_vm._s(_vm.$t("sideMenu.mySubscriptions")))])
              ])
            ]
          ),
          _c("span", { staticClass: "links-header" }, [
            _vm._v(_vm._s(_vm.$t("sideMenu.pages")))
          ]),
          _c(
            "router-link",
            {
              staticClass: "link",
              class: _vm.checkIsActivePage("/resources"),
              attrs: { tag: "span", to: "/resources" },
              nativeOn: {
                click: function($event) {
                  return _vm.closeMenu("RESOURCES")
                },
                mouseenter: function($event) {
                  return _vm.openSideMenuOverflowElement($event)
                }
              }
            },
            [
              _c("div", { staticClass: "hover-container" }, [
                _c("img", {
                  attrs: {
                    src: require("@/common/assets/icons/question.svg"),
                    alt: "question"
                  }
                }),
                _c("span", [_vm._v(_vm._s(_vm.$t("sideMenu.FAQs")))])
              ])
            ]
          ),
          _vm.showLanguageOptions && _vm.$route.meta.headerColor !== "dark"
            ? _c("ApplicationLanguageControl", {
                attrs: { containerClasses: ["mt-30", "mobile"] }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "hover-container create-story-button gop-container" },
      [
        _c("img", {
          attrs: {
            src: require("@/common/assets/icons/platform.svg"),
            alt: "platform"
          }
        }),
        _c("span", [_vm._v("GOP")])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }